import storageManager from './StorageManager';

export const SESSION_SCOPED_FLAG = '__sessionScoped';
export const SESSION_SCOPED_CODE = '__sessionCode';

export const SESSION_GAME_CACHE_KEYS = [
    'uno_game_state',
    'uno_nm_game_state',
    'trio_game_state',
    'charades_game_state',
    'mafia_game_state',
    'mafia_reveal_state',
    'mafia_narrator_state',
    'imposter_setup',
    'imposter_reveal_state',
    'imposter_voting_state',
];

export const VIRTUAL_IMPOSTER_PRESENCE_KEY = 'virtual_imposter_presence';

export const normalizeSessionCode = (value) => String(value || '').trim().toUpperCase();

export const stampSessionScopedGameState = (payload, isSessionMode, sessionCode) => {
    const data = payload && typeof payload === 'object' ? { ...payload } : {};
    const normalizedCode = normalizeSessionCode(sessionCode);
    if (isSessionMode && normalizedCode) {
        data[SESSION_SCOPED_FLAG] = true;
        data[SESSION_SCOPED_CODE] = normalizedCode;
    } else {
        delete data[SESSION_SCOPED_FLAG];
        delete data[SESSION_SCOPED_CODE];
    }
    return data;
};

export const isSessionScopedGameState = (payload) => Boolean(payload && payload[SESSION_SCOPED_FLAG]);

export const getSessionScopedGameStateCode = (payload) => {
    if (!isSessionScopedGameState(payload)) return '';
    return normalizeSessionCode(payload?.[SESSION_SCOPED_CODE]);
};

export const canUseCachedGameStateInContext = (payload, isSessionMode, sessionCode) => {
    if (!payload || typeof payload !== 'object') return false;
    const scoped = isSessionScopedGameState(payload);
    const normalizedCode = normalizeSessionCode(sessionCode);

    if (isSessionMode) {
        if (!scoped) return false;
        return getSessionScopedGameStateCode(payload) === normalizedCode;
    }

    return !scoped;
};

export const clearSessionGameStateCaches = (sessionCode = '') => {
    SESSION_GAME_CACHE_KEYS.forEach((cacheKey) => {
        storageManager.removeTemporaryData(cacheKey);
    });
    storageManager.removeTemporaryData(VIRTUAL_IMPOSTER_PRESENCE_KEY);

    const normalizedCode = normalizeSessionCode(sessionCode);
    if (normalizedCode) {
        storageManager.removeTemporaryData(`guest_session_presence_${normalizedCode}`);
    }
};
